import { operationsRoutes } from '@/routes/protected/operations-routes';
import { Home } from '@mui/icons-material';
import {
  BarChart3,
  BookTemplate,
  Box,
  Image,
  LayoutDashboard,
  MessageSquare,
  Package,
  Receipt,
  Settings,
  ShoppingBag,
  Store,
  Users,
  type LucideIcon
} from 'lucide-react';

// Interface for menu items
export interface MenuItem {
  title: string;
  path: string;
  icon: LucideIcon;
  badge?: number;
  submenu?: MenuItem[];
}

// Interface for menu section
export interface MenuSection {
  title: string;
  items: MenuItem[];
}

// Menu sections with logical grouping
// title values are i18n keys under layout.navigation.*
export const menuSections: MenuSection[] = [
  {
    title: 'navigation.sectionCommunication',
    items: [
      {
        title: 'navigation.chat',
        path: '/chat',
        icon: MessageSquare,
      },
    ],
  },
  {
    title: 'navigation.sectionSales',
    items: [
      {
        title: 'navigation.sale',
        path: '/sale',
        icon: ShoppingBag,
      },
      {
        title: 'navigation.order',
        path: '/orders',
        icon: Receipt,
      },
    ],
  },
  {
    title: 'layout:navigation.sectionManagement',
    items: [
      {
        title: 'layout:navigation.customer',
        path: '/customers',
        icon: Users,
      },
      {
        title: 'layout:navigation.product',
        path: '/products',
        icon: Package,
      },
      {
        title: 'layout:navigation.productVariants',
        path: '/product-variants',
        icon: Box,
      },
      {
        title: 'layout:navigation.stock',
        path: '/stocks',
        icon: Store,
      },
    ],
  },
  {
    title: 'navigation.sectionAnalytics',
    items: [
      {
        title: 'navigation.report',
        path: '/reports',
        icon: BarChart3,
      },
      {
        title: 'navigation.stockMovement',
        path: operationsRoutes.stockMovements.path,
        icon: Box,
      },
      {
        title: 'navigation.dashboard',
        path: '/dashboard',
        icon: LayoutDashboard,
      },
    ],
  },
  {
    title: 'navigation.sectionSystem',
    items: [
      {
        title: 'navigation.messageTemplates',
        path: '/message-templates',
        icon: BookTemplate,
      },
      {
        title: 'navigation.userManagement',
        path: '/users',
        icon: Users,
      },
      {
        title: 'navigation.mediaManagement',
        path: '/media-management',
        icon: Image,
      },
      {
        title: 'navigation.settings',
        path: '/settings',
        icon: Settings,
      },
    ],
  },
];
